module.exports = __webpack_public_path__ + "img/trunk_11x1.ce4d944d.svg";